<mat-toolbar>

  <span>
    <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon" (click)="loadTreeData()" matTooltip="Обновить содержимое страницы">
      <mat-icon>refresh</mat-icon>
    </button>
  </span>

  <span>
    <td mat-cell *matCellDef="let element"></td>
    <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon"
      (click)="Add_menu_item()" matTooltip="Добавить содержимое страницы">
      <mat-icon>add</mat-icon>
    </button>
  </span>


  <span class="flexExpand"></span>


</mat-toolbar>
<div class="tree-editor-container">
  <div class="tree-toolbar">
    <mat-form-field class="tree-search">
      <mat-label>Поиск в дереве</mat-label>
      <input matInput (keyup)="filterTree($event)" placeholder="Поиск по названию">
    </mat-form-field>
  </div>
  
  <div class="tree-view mat-elevation-z2">
    <mat-tree [dataSource]="treeDataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <button mat-icon-button matTreeNodeToggle
                [attr.aria-label]="'Toggle ' + node.ShortTitle">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        
        <div class="tree-node-item">
          <div class="tree-node-content">
            <!-- Режим редактирования -->
            <div *ngIf="node.isEditing" class="edit-form-inline">
              <mat-form-field class="tree-edit-field">
                <input matInput [(ngModel)]="node.ShortTitle" placeholder="Название"  (change)="updateNodeValue(node, 'ShortTitle', node.ShortTitle)">
              </mat-form-field>
              <mat-form-field class="tree-edit-field">
                <input matInput [(ngModel)]="node.Type" placeholder="Тип"  (change)="updateNodeValue(node, 'Type', node.Type)">
              </mat-form-field>
              <mat-form-field class="tree-edit-field">
                <input matInput [(ngModel)]="node.NamePage" placeholder="Страница"  (change)="updateNodeValue(node, 'ShortTitle', node.ShortTitle)" (change)="updateNodeValue(node, 'NamePage', node.NamePage)">
              </mat-form-field>
              <mat-form-field class="tree-edit-field-small">
                <input matInput [(ngModel)]="node.Order" type="number" placeholder="Порядок"  (change)="updateNodeValue(node, 'Order', node.Order)">>
              </mat-form-field>
            
              <mat-checkbox class="default-checkbox" 
                           [(ngModel)]="node.Default" 
                           (change)="updateNodeValue(node, 'Default', node.Default)">
                По умолчанию
              </mat-checkbox>
            </div>
            
            <!-- Режим просмотра -->
            <div *ngIf="!node.isEditing" class="tree-node-display" (click)="treeControl.toggle(node)">
              <span class="tree-node-title">{{node.ShortTitle}}</span>
              
              <mat-icon class="tree-checkmark" *ngIf="node.Default" matTooltip="По умолчанию" color="primary">
                check_circle
              </mat-icon>
              
              <span class="tree-node-type">{{node.Type}}</span>
              <span class="tree-node-page" *ngIf="node.NamePage">{{node.NamePage}}</span>
            </div>
          </div>
          
          <!-- Кнопки действий -->
          <div class="tree-node-actions">
            <!-- Кнопка Редактировать - показываем если не в режиме редактирования -->
            <button mat-icon-button *ngIf="!node.isEditing" (click)="startTreeEdit(node)" matTooltip="Редактировать">
              <mat-icon>edit</mat-icon>
            </button>
            
            <!-- Кнопка Сохранить - показываем если в режиме редактирования -->
            <button mat-icon-button *ngIf="node.isEditing" (click)="saveTreeEdit(node)" matTooltip="Сохранить" color="primary">
              <mat-icon>save</mat-icon>
            </button>
            
            <!-- Кнопка Отменить - показываем если в режиме редактирования -->
            <button mat-icon-button *ngIf="node.isEditing" (click)="cancelTreeEdit(node)" matTooltip="Отменить">
              <mat-icon>cancel</mat-icon>
            </button>
            
            <!-- Кнопка Добавить подпункт - всегда видна -->
            <button mat-icon-button (click)="addTreeChild(node)" matTooltip="Добавить подпункт">
              <mat-icon>add</mat-icon>
            </button>
            
            <!-- Кнопка Удалить - всегда видна -->
            <button mat-icon-button (click)="Delete_menu_item(node)" matTooltip="Удалить">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </mat-tree-node>
    </mat-tree>
  </div>
  
  <div class="tree-info">
    <small>Всего пунктов: {{getTotalItemsCount()}} | 
    <button mat-button (click)="expandAll()">Развернуть всё</button>
    <button mat-button (click)="collapseAll()">Свернуть всё</button>
    </small>
  </div>
</div>